<div class="spinner spinner-{{ color }}">
  <span class="spinner-border" role="status"></span>
</div>
